import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import content from '../content/siteContent.json';

const Header = () => {
  const { header } = content;
  const [open, setOpen] = useState(false);

  const toggle = () => setOpen((v) => !v);
  const close = () => setOpen(false);

  return (
    <header className="header">
      <div className="logo" aria-label="TakenoStudio logo">
        <span className="logo__dot">{header.logoDot}</span>
        <span className="logo__text">{header.logoText}</span>
      </div>
      <button className="nav-toggle" aria-expanded={open} onClick={toggle}>
        <span />
        <span />
        <span />
      </button>
      <nav className={`nav ${open ? 'is-open' : ''}`}>
        {header.nav.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) => `nav__link ${isActive ? 'is-active' : ''}`}
            onClick={close}
          >
            {item.label}
          </NavLink>
        ))}
        <a className="btn btn-primary" href={`mailto:${header.contactEmail}`} onClick={close}>
          {header.contactCta}
        </a>
      </nav>
    </header>
  );
};

export default Header;
